<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.users'), $t('text.list')]">
        <el-button
          v-if="!Permit.isFreeEdition()"
          type="success"
          size="mini"
          @click="add"
        >
          + {{ $t("text.create") }}
        </el-button>
      </breadcrumb>
    </div>

    <div
      v-if="!Permit.isFreeEdition() && tenant != null"
      class="red font16 center pd10"
    >
      您的账户可授权{{
        tenant.charge.validQuantity + tenant.charge.addedQuantity
      }}个子账户，已授权{{ tenant.charge.authorizedQuantity }}个
      <span
        v-if="
          tenant.charge.validQuantity +
            tenant.charge.addedQuantity -
            tenant.charge.authorizedQuantity <
          0
        "
        >，还需购买{{
          tenant.charge.validQuantity +
          tenant.charge.addedQuantity -
          tenant.charge.authorizedQuantity
        }}个，请联系客服购买</span
      >
    </div>

    <narrow
      v-if="!Permit.isFreeEdition()"
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.namePhone')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="usersTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="name"
          :title="$t('user.name')"
          min-width="140"
        />
        <vxe-table-column
          field="phone"
          :title="$t('user.account')"
          min-width="140"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('user.shop')"
          min-width="160"
        />
        <vxe-table-column
          field="authorize"
          :title="$t('user.authorize')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <span v-if="!row.admin">
              <span v-if="row.voidAt == null">
                <span v-if="row.authorize" class="orange">
                  {{ $t("authorizes.authorized") }}
                </span>
                <span v-else class="green">
                  {{ $t("authorizes.unAuthorize") }}
                </span>
                <!-- <div class="font10">
                  <span :class="row.dataAuth == true ? 'green' : 'grey-shallow'">
                    {{ $t("action.authData") }}
                  </span>
                  <span
                    :class="row.coreOperateAuth == true ? 'green' : 'grey-shallow'"
                  >
                    {{ $t("action.authData") }}
                  </span>
                </div> -->
              </span>
              <span v-if="row.voidAt != null" class="grey">{{
                $t("authorizes.void")
              }}</span>
            </span>
            <div v-else>{{ $t("authorizes.admin") }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="webToken"
          :title="$t('user.token')"
          min-width="140px"
        >
          <template v-slot="{ row, rowIndex }">
            <span
              class="blue"
              v-if="!row.showWebTokenDF"
              @click="showWebToken(row, rowIndex)"
            >
              {{ $t("text.view") }}
            </span>
            <span v-if="row.showWebTokenDF">{{ row.webToken }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="!Permit.isFreeEdition()"
          field="action"
          :title="$t('text.action')"
          width="170"
        >
          <template v-slot="{ row, rowIndex }">
            <span v-if="row.voidAt == null">
              <el-button type="text" size="mini" @click="edit(row)">{{
                $t("text.edit")
              }}</el-button>
              <el-button
                v-if="!row.admin"
                type="text"
                size="mini"
                @click="editPassword(row)"
                >{{ $t("action.resetPassword") }}</el-button
              >
              <el-button
                v-if="!row.admin && !row.authorize"
                type="text"
                size="mini"
                @click="deleteRow(row)"
                >{{ $t("text.delete") }}</el-button
              >
              <el-button
                v-if="!row.admin && row.authorize"
                type="text"
                size="mini"
                @click="setInvalid(row)"
                >{{ $t("action.setInvalid") }}</el-button
              >
              <div v-if="!row.admin">
                <el-button
                  type="text"
                  size="mini"
                  @click="auth(row, rowIndex, 'data')"
                  >{{ $t("action.authData") }}</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="auth(row, rowIndex, 'action')"
                  >{{ $t("action.authAction") }}</el-button
                >
              </div>
            </span>
            <template v-else>
              <el-button
                type="text"
                size="mini"
                @click="recovery(row)"
                v-if="
                  tenant &&
                  tenant.charge &&
                  tenant.charge.validQuantity + tenant.charge.addedQuantity >
                    tenant.charge.authorizedQuantity
                "
              >
                {{ $t("action.recovery") }}
              </el-button>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 新增子账户 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-form-item
          :label="$t('user.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addObj.name" />
        </el-form-item>
        <el-form-item
          :label="$t('user.account')"
          :prop="'phone'"
          :rules="[
            { required: true, validator: validatePhoneAdd, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addObj.phone"
            :placeholder="$t('prompt.alphabetNumber')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('user.password')"
          :prop="'password'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.password')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addObj.password"
            type="password"
          />
        </el-form-item>
        <el-form-item :label="$t('user.shop')" :prop="'shopId'">
          <el-select size="small" v-model="addObj.shopId" clearable filterable>
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑子账户 -->
    <el-dialog
      :title="$t('text.edit')"
      :visible.sync="editDF"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <el-form-item
          :label="$t('user.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.name" />
        </el-form-item>
        <el-form-item
          v-if="!row.admin"
          :label="$t('user.account')"
          :prop="'phone'"
          :rules="[
            { required: true, validator: validatePhoneEdit, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.phone"
            :placeholder="$t('prompt.alphabetNumber')"
          />
        </el-form-item>
        <el-form-item :label="$t('user.shop')" :prop="'shopId'">
          <el-select size="small" v-model="editObj.shopId" clearable filterable>
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog
      :title="$t('action.resetPassword')"
      :visible.sync="editPasswordDF"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="editPasswordObjForm"
        :model="editPasswordObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('user.password')"
          :prop="'password'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.password')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editPasswordObj.password"
            :placeholder="$t('user.password')"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPasswordDoing"
          size="small"
          @click="editPasswordSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPasswordDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('action.authData')"
      :visible.sync="showAuthDataDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <auth-data :id="currentRowId" @updateInfo="closeAuthDataUpdateInfo" />
    </drawer>

    <drawer
      :title="$t('action.authAction')"
      :visible.sync="showAuthActionDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <auth-action :id="currentRowId" @updateInfo="closeAuthDataUpdateInfo" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import Tenant from "@/api/tenant.js";
import AuthData from "./authData.vue";
import AuthAction from "./authAction.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.sorter,
    table.basic,
  ],
  components: { AuthData, AuthAction },
  data() {
    var validatePhoneAdd = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(self.$t("rules.required", [self.$t("user.account")]));
        return;
      }
      if (!Util.regexAlphabetNumber(value)) {
        callback(self.$t("rules.regex", [self.$t("user.account")]));
        return;
      }
      if (value.match(/\D/) == null) {
        callback(this.$t("prompt.atLastOneAlphabet"));
        return;
      }
      User.findByPhone({ phone: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(self.$t("rules.exist", [self.$t("user.account")]));
        } else {
          callback();
        }
      });
    };
    var validatePhoneEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(self.$t("rules.required", [self.$t("user.account")]));
        return;
      }
      if (!Util.regexAlphabetNumber(value)) {
        callback(self.$t("rules.regex", [self.$t("user.account")]));
        return;
      }
      if (value.match(/\D/) == null) {
        callback(this.$t("prompt.atLastOneAlphabet"));
        return;
      }
      User.findByPhone({ phone: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.row.id) {
          callback(self.$t("rules.exist", [self.$t("user.account")]));
        } else {
          callback();
        }
      });
    };
    return {
      searchForm: {
        keyword: null,
      },
      narrows: [
        [
          {
            label: this.$t("user.voidInfo"),
            items: [
              {
                label: this.$t("authorizes.noVoid"),
                key: "voidAtNo",
                condition: { voidAt: "no" },
              },
              {
                label: this.$t("authorizes.void"),
                key: "voidAtYes",
                condition: { voidAt: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: "voidAtNo",
      sorter: {
        sortBy: "users_id",
        sortIndicator: "desc",
      },
      //
      tenant: null,
      // 新增子账户
      validatePhoneAdd: validatePhoneAdd,
      addDF: false,
      addObj: {
        name: null,
        phone: null,
        password: null,
        shopId: null,
        unionid: null,
        webToken: null,
        appToken: null,
      },
      addDoing: false,
      // 编辑
      validatePhoneEdit: validatePhoneEdit,
      shops: [],
      row: { admin: null },
      editDF: false,
      editObj: {
        name: null,
        phone: null,
        shopId: null,
        printerSn: null,
      },
      editDoing: false,
      //编辑密码
      editPasswordDF: false,
      editPasswordObj: {
        password: null,
      },
      editPasswordDoing: false,
      //
      currentRowId: null,
      currentRowIdx: null,
      showAuthDataDF: false,
      showAuthActionDF: false,
    };
  },
  created() {
    const self = this;
    if (!self.Permit.isFreeEdition()) {
      self.getTenant();
    }
  },
  methods: {
    recovery(row) {
      const self = this;
      User.recovery(row.id).then(function (res) {
        if (res.status === 200) {
          self.sysError(res.data);
          self.loadData();
          self.getTenant();
        } else {
          self.sysError();
        }
      });
    },
    showWebToken(row, rowIndex) {
      this.records[rowIndex].showWebTokenDF =
        !this.records[rowIndex].showWebTokenDF;
    },
    closeAuthDataUpdateInfo() {
      this.showAuthDataDF = false;
      this.showAuthActionDF = false;
      this.records[this.currentRowIdx].authorize = true;
    },
    auth(row, rowIndex, type) {
      const self = this;
      const canAuthQty =
        self.tenant.charge.validQuantity + self.tenant.charge.addedQuantity;
      if (
        row.authorize ||
        (!row.authorize && canAuthQty > self.tenant.charge.authorizedQuantity)
      ) {
        self.currentRowId = row.id;
        self.currentRowIdx = rowIndex;
        if (type == "data") {
          self.showAuthDataDF = true;
        } else {
          self.showAuthActionDF = true;
        }
      } else {
        self.$message({
          message: self.$t("prompt.authQtyBeyond"),
          type: "warning",
        });
      }
    },
    // 设置失效
    setInvalid(row) {
      const self = this;
      if (confirm(this.$t("prompt.setInvalid"))) {
        User.invalid(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.setSuccess"),
              type: "success",
            });
            self.loadData();
            self.getTenant();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        User.invalid(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.getTenant();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑密码
    editPassword(row) {
      const self = this;
      self.row = row;
      self.editPasswordObj.password = null;
      self.editPasswordDoing = false;
      self.editPasswordDF = true;
    },

    editPasswordSubmit() {
      const self = this;
      self.$refs.editPasswordObjForm.validate((valid) => {
        if (valid) {
          self.editPasswordDoing = true;
          User.updatePassword(self.row.id, self.editPasswordObj).then(function (
            res
          ) {
            self.editPasswordDoing = false;
            self.editPasswordDF = false;
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
          });
        } else {
          return false;
        }
      });
    },
    // 编辑子账户
    edit(row) {
      const self = this;
      self.row = row;
      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
          if (self.shops.map((s) => s.id == row.shopId) == null) {
            self.editObj.shopId = null;
          } else {
            self.editObj.shopId = row.shopId;
          }
          self.editObj.name = row.name;
          self.editObj.phone = row.phone;
          self.editObj.printerSn = row.printerSn;
          self.editSubmitDoing = false;
          self.editDF = true;
        } else {
          self.sysError();
        }
      });
    },
    editSubmit() {
      const self = this;
      this.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          User.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.loadData();
          });
        } else {
          return false;
        }
      });
    },
    // 新增子账户
    add() {
      const self = this;
      self.addObj.name = null;
      self.addObj.phone = null;
      self.addObj.password = null;
      self.addObj.shopId = null;
      self.addObj.unionid = null;
      self.addDoing = false;
      self.addDF = true;
      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
        } else {
          self.sysError();
        }
      });
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.addObj.unionid = "web-" + Util.randNNumber(29);
          self.addObj.webToken = self.addObj.unionid;
          self.addObj.appToken = self.addObj.unionid;
          self.addDoing = true;
          User.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
            self.loadData();
            self.getTenant();
          });
        } else {
          return false;
        }
      });
    },

    getTenant() {
      const self = this;
      Tenant.findById(self.Permit.currentTenant().id).then(function (res) {
        if (res.data.code === 200) {
          self.tenant = res.data.entity;
        } else {
          self.sysError();
        }
      });
    },
    //
    dataProvider(params) {
      return User.search(params);
    },
    recordsDecorate(records) {
      for (const r of records) {
        Vue.set(r, "showWebTokenDF", false);
      }
      this.records = records;
    },
  },
};
</script>
<style scoped>
</style>